<ng-container *ngIf="!isDataModified; then spinnerTemplate else mainTemplate"></ng-container>

<ng-template #spinnerTemplate></ng-template>

<ng-template #mainTemplate>
  
  <div #wrapperElement class="frame-wrapper" [ngStyle]="frameBasiStyles">
    Google Wallet

    <div (wheel)="onMouseWheel($event)" class="frame-wrapper__device h-100 w-100 " [ngStyle]="{'background-color': getBgColor(walletConfig?.color)}">
        
        <!-- image background -->
        <!--img *ngIf="mediaData.is_background_image" class="frame-wrapper__image h-100 w-100" [src]="mediaData.background_url" alt="background_url" -->
        <!-- video background -->
        <!--video *ngIf="!mediaData.is_background_image" id="videoPlayer" class="frame-wrapper__video" width="100%" height="100%" [muted]="true" loop autoplay playsinline>
          <source [src]="mediaData.background_url" type="video/mp4">
        </video -->
        <!--div class="frame-wrapper__image frame-wrapper__device-bgdarker h-100 w-100"></div -->
  
        <div style="position: relative; margin: 20px 10px; text-align: left;" >

            <span *ngIf="mediaData?.type !== 'WC'" class="frame-wrapper__container-profile-image">
            <img   [src]="cardIcon" (error)="setDefaultIcon()" >
            </span>
            
            <span class="frame-wrapper__container-header-name" style="margin-left: 10px;" [style.color]="clientColor">
                {{walletConfig?.header_title}}
            </span>
        </div>

        <hr style="position:  relative;padding: 0; background-color: #fafafaff; opacity: 30%;" />
     
      
  
  
      <div  class="frame-wrapper__container" [ngClass]="isWindowInnerHeightGreater800 ? 'frame-wrapper__container-bigscreen' : 'frame-wrapper__container-smallscreen' ">
        <!-- profile -->
        <!--div class="frame-wrapper__container-profile" *ngIf="!isHideAllContain && !isShowModalCardInfo"
          [ngClass]="{'frame-wrapper__container-profile-totop': isShowAllActions, 'frame-wrapper__zindex0': isShowAllActions, 'frame-wrapper__container-profile-tobottom': !isShowAllActions, 'frame-wrapper__container-profile-tobottomfix': iconLogoToBottom, 'frame-wrapper__container-profile-totopdefault': iconLogoToDefault}" -->
        
        <div class="frame-wrapper__container-profile">
  
          <div class="frame-wrapper__container-profile-text" [style.color]="clientColor">
            <div class="frame-wrapper__container-profile-description" [style.color]="clientColor" > [employee-position] </div>
            <div class="frame-wrapper__container-profile-name" [style.color]="clientColor">Name 002</div>
            

            <div class="frame-wrapper__container-profile-mobile" [style.color]="clientColor">[employee-mobile]</div>
            <hr style="padding: 0; background-color: #fafafaff; opacity: 30%;"/>
            <div class="frame-wrapper__container-profile-email" [style.color]="clientColor"> [employee-email] </div>
            
            
          </div>
        </div>

        <!-- Qrcode-->
        <div class="frame-wrapper__container" style="position: relative; margin-top: 10px; width: 100%; text-align: center;">
          <div  style="width:50%; padding: 10px; margin:0 auto; background-color: #fafafaff; border-radius: 1em"   >
            <qrcode [qrdata]="getUrl('https://codezero.app')" [colorLight]="'#fafafaff'" [colorDark]="'#3e3e3eff'" [width]="150" [elementType]="'img'" [margin]="0" [errorCorrectionLevel] ="'M'" ></qrcode>
          </div>
        </div>
  
        <!-- icons action -->
        <div *ngIf="isShowAllActions && iconsAnimation" class="frame-wrapper__container-icon">
          <app-wallet-icons [mediaData]="mediaData" (iconActionSender)="listenIconAction($event)" [currentStep]="currentStep" [barColor]="barColor"></app-wallet-icons>
        </div>

        <div #logoElement *ngIf="!isShowModalCardInfo" class="frame-wrapper__logo" >
          <div class="lbox">
          <img *ngIf="cardIcon" (click)="openCardInfo()" [src]="cardLogo" [ngClass]="{'frame-wrapper__topper-clickable': isShowProfileInfo}" >
          </div>
      
        </div>
  
        
      </div>
  
      <!-- feature wrapper -->
      <!--div class="frame-wrapper__feature" *ngIf="isHideAllContain && isShowFeatureContent">
        <app-frame-feature [mediaData]="mediaData" [fullPreview]="fullPreview" (goBackToMainIcons)="listenOnGoBack($event)"></app-frame-feature>
      </div-->
  
      <!-- profile wrapper -->
      <!--div class="frame-wrapper__profile" *ngIf="isHideAllContain && isShowProfile">
        <app-frame-profile [mediaData]="mediaData" (goBackToMainIcons)="listenOnGoBack($event)"></app-frame-profile>
      </div -->
  
    </div>
    If want preview in device,
    <div class="w_button">
      <button (click)="getWalletUrl(mediaData?.md5)">Add to Google Wallet</button>
    </div>
  </div>
  <textarea rows="5" cols="60" style="margin-top: 80px;">
    {{getWalletUrl2(mediaData?.md5)}}
  </textarea>
</ng-template>